import { useEffect } from "react";
import { CommandCenterGrid } from "./CommandCenterGrid";
import { useDispatch } from "react-redux";
import { setPageTitle } from "../../store/slices/pageTitleSlice";


export const CommandCenter = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setPageTitle('Command Center | Spire360'));
  }, []);

  return (
    <>
      <CommandCenterGrid breadcrumbs={true}/>
    </>
  );
};
